import { Navigate } from "react-router-dom";
import { useOldMemberStatus } from "@/hooks/useLegacyNotes";
import PageSkeleton from "@/components/PageSkeleton";

interface Props {
  children: React.ReactNode;
}

export default function OldMemberGuard({ children }: Props) {
  const { data, isLoading } = useOldMemberStatus();

  if (isLoading) {
    return <PageSkeleton variant="dashboard" />;
  }

  if (!data?.is_old_member) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
}
